import { ContactIconText } from "./ContactIconText/ContactIconText";
import Input from "./Inputs/Input";

export default function ContactPerson({ errors, register }) {
  return (
    <div className="div">
      <div className="icon-text-wrapper">
        <ContactIconText />
      </div>

      <Input
        label="Ime"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="contactFname"
        name="contactFname"
        placeholder="Ime"
        error={errors.contactFname?.message}
        register={register}
      />
      <Input
        label="Priimek"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="contactSname"
        name="contactSname"
        placeholder="Priimek"
        error={errors.contactSname?.message}
        register={register}
      />
      <Input
        label="E-naslov"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="contactEmail"
        name="contactEmail"
        placeholder="E-naslov"
        error={errors.contactEmail?.message}
        register={register}
      />
      <Input
        label="Telefon"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id="contactPhone"
        name="contactPhone"
        placeholder="Telefon"
        maxLength={20}
        error={errors.contactPhone?.message}
        register={register}
      />
    </div>
  );
}
